import useAudioStore from '../audio.store.tsx'
import useTracksStore, { MIX_ID } from '../tracks.store.tsx'
import { mixTracks } from '../../../utils/mix-tracks.ts'
import { useHistoryStore } from '../history.store.tsx'
import useMediaStore from '../media.store.tsx'

export const refreshAudioMix = async (
  withSaveSnapshot = true
): Promise<void> => {
  if (withSaveSnapshot) {
    const historyStore = useHistoryStore.getState()
    historyStore.saveSnapshot()
  }

  const audioStore = useAudioStore.getState()
  if (audioStore.currentAudioId !== MIX_ID || audioStore.isPaused) return

  const { tracks, maxProjectDuration } = useTracksStore.getState()
  const { media } = useMediaStore.getState()
  const mixBuffer = await mixTracks(
    tracks,
    media,
    audioStore.audioContext,
    maxProjectDuration
  )
  audioStore.playAudioBuffer(MIX_ID, mixBuffer, audioStore.progress)
}
